export const APP_NAME = 'EfaSoft'
